var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeliefsStars({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 278,
    height: 189,
    viewBox: "0 0 278 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1023_3319)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 107.001C28.1493 107.001 82 122.911 82 189.001C82 122.911 135.851 107.001 164 107.001C97.9104 107.001 82 53.15 82 25.0007C82 53.15 66.0896 107.001 0 107.001Z",
    fill: "#BFB5FF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5 189.001C82.5 155.797 68.9615 135.145 51.8483 122.812C34.761 110.496 14.1506 106.501 0 106.501V107.501C13.9987 107.501 34.3882 111.46 51.2636 123.623C68.1131 135.767 81.5 156.115 81.5 189.001H82.5ZM82.5 189.001C82.5 156.115 95.8869 135.767 112.736 123.623C129.612 111.46 150.001 107.501 164 107.501V106.501C149.849 106.501 129.239 110.496 112.152 122.812C95.0385 135.145 81.5 155.797 81.5 189.001H82.5ZM81.5 25.0007C81.5 39.1513 85.4956 59.7618 97.8108 76.849C110.145 93.9623 130.796 107.501 164 107.501V106.501C131.114 106.501 110.766 93.1138 98.622 76.2644C86.4596 59.389 82.5 38.9994 82.5 25.0007H81.5ZM0 107.501C33.2037 107.501 53.8554 93.9623 66.1892 76.849C78.5044 59.7618 82.5 39.1513 82.5 25.0007H81.5C81.5 38.9994 77.5404 59.389 65.378 76.2644C53.2342 93.1138 32.8859 106.501 0 106.501V107.501Z",
    fill: "url(#paint0_linear_1023_3319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5 189.001C82.5 155.797 68.9615 135.145 51.8483 122.812C34.761 110.496 14.1506 106.501 0 106.501V107.501C13.9987 107.501 34.3882 111.46 51.2636 123.623C68.1131 135.767 81.5 156.115 81.5 189.001H82.5ZM82.5 189.001C82.5 156.115 95.8869 135.767 112.736 123.623C129.612 111.46 150.001 107.501 164 107.501V106.501C149.849 106.501 129.239 110.496 112.152 122.812C95.0385 135.145 81.5 155.797 81.5 189.001H82.5ZM81.5 25.0007C81.5 39.1513 85.4956 59.7618 97.8108 76.849C110.145 93.9623 130.796 107.501 164 107.501V106.501C131.114 106.501 110.766 93.1138 98.622 76.2644C86.4596 59.389 82.5 38.9994 82.5 25.0007H81.5ZM0 107.501C33.2037 107.501 53.8554 93.9623 66.1892 76.849C78.5044 59.7618 82.5 39.1513 82.5 25.0007H81.5C81.5 38.9994 77.5404 59.389 65.378 76.2644C53.2342 93.1138 32.8859 106.501 0 106.501V107.501Z",
    fill: "url(#paint1_linear_1023_3319)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_1023_3319)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149 64.5C171.142 64.5 213.5 77.0149 213.5 129C213.5 77.0149 255.858 64.5 278 64.5C226.015 64.5 213.5 22.1418 213.5 0C213.5 22.1418 200.985 64.5 149 64.5Z",
    fill: "#BFB5FF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214 129C214 102.849 203.335 86.5719 189.846 76.85C176.382 67.1467 160.147 64 149 64V65C159.995 65 176.01 68.1107 189.261 77.6612C202.486 87.1931 213 103.166 213 129H214ZM214 129C214 103.166 224.514 87.1931 237.739 77.6612C250.991 68.1107 267.005 65 278 65V64C266.853 64 250.618 67.1467 237.154 76.85C223.665 86.5719 213 102.849 213 129H214ZM213 0C213 11.1469 216.147 27.3823 225.85 40.8455C235.572 54.3347 251.849 65 278 65V64C252.166 64 236.193 53.4862 226.661 40.2608C217.111 27.0095 214 10.9949 214 0H213ZM149 65C175.151 65 191.428 54.3347 201.15 40.8455C210.853 27.3823 214 11.1469 214 0H213C213 10.9949 209.889 27.0095 200.339 40.2608C190.807 53.4862 174.834 64 149 64V65Z",
    fill: "url(#paint2_linear_1023_3319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214 129C214 102.849 203.335 86.5719 189.846 76.85C176.382 67.1467 160.147 64 149 64V65C159.995 65 176.01 68.1107 189.261 77.6612C202.486 87.1931 213 103.166 213 129H214ZM214 129C214 103.166 224.514 87.1931 237.739 77.6612C250.991 68.1107 267.005 65 278 65V64C266.853 64 250.618 67.1467 237.154 76.85C223.665 86.5719 213 102.849 213 129H214ZM213 0C213 11.1469 216.147 27.3823 225.85 40.8455C235.572 54.3347 251.849 65 278 65V64C252.166 64 236.193 53.4862 226.661 40.2608C217.111 27.0095 214 10.9949 214 0H213ZM149 65C175.151 65 191.428 54.3347 201.15 40.8455C210.853 27.3823 214 11.1469 214 0H213C213 10.9949 209.889 27.0095 200.339 40.2608C190.807 53.4862 174.834 64 149 64V65Z",
    fill: "url(#paint3_linear_1023_3319)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1023_3319",
    x: -13.8566,
    y: 11.1441,
    width: 191.713,
    height: 191.713,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.92831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1023_3319"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1023_3319",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1023_3319",
    x: 135.143,
    y: -13.8566,
    width: 156.713,
    height: 156.713,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6.92831
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1023_3319"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1023_3319",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1023_3319",
    x1: 7.68872,
    y1: 174.419,
    x2: 190.646,
    y2: 125.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1023_3319",
    x1: 7.68872,
    y1: 174.419,
    x2: 190.646,
    y2: 125.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141D75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1023_3319",
    x1: 155.048,
    y1: 117.53,
    x2: 298.959,
    y2: 78.7307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1023_3319",
    x1: 155.048,
    y1: 117.53,
    x2: 298.959,
    y2: 78.7307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141D75"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeliefsStars);
export default __webpack_public_path__ + "static/media/beliefs_stars.9e2f47d05c8933567127d75b913ad774.svg";
export { ForwardRef as ReactComponent };